<mat-form-field class="number-range-input">
  <mat-label>{{ label }}</mat-label>
  <input matInput [placeholder]="label" [value]="value ?? ''" [disabled]="disabled"
    (input)="onInput($event)" (blur)="onTouched()">
  <button mat-icon-button matSuffix type="button" (click)="assignNext()" [disabled]="!canAssign"
    [matTooltip]="assignTooltip">
    <mat-icon>exposure_plus_1</mat-icon>
  </button>
  @if (range) {
    <mat-hint>{{ range.key }}: {{ range.actual }} ({{ range.min }}–{{ range.max }})</mat-hint>
  } @else if (rangeError) {
    <mat-hint class="number-range-input__error">{{ rangeError }}</mat-hint>
  } @else if (!rangeKey) {
    <mat-hint>No number range selected</mat-hint>
  }
</mat-form-field>
